import React from 'react';
import '../../App.css';

import Cabecalho from '../../components/Cabecalho';
import Carregando from '../../components/Carregando';
import Times from '../../components/Times';
import Grupo from '../../components/Grupo';

import Campeonato from '../../services/Campeonato';

import montarGrupos from '../../utils/montarGrupos';
import env from '../../constants/env';

export default class AcompanhamentoScreen extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      acompanhamentoDisponivel: true,
      countAcao: 0,
      loading: true,
      titulo: '',
      mensagem: '',
      timeSelecionado: { id: 0, nome: '' },
      times: [],
      jogadores: [],
      selecaoRecente: false,
      jogadores1: [],
      jogadores2: [],
      grupo1: [],
      grupo2: [],
    };

    // BINDS
    this.inicializar = this.inicializar.bind(this);
    this.selecionarTime = this.selecionarTime.bind(this);
    this.cancelarSelecaoTime = this.cancelarSelecaoTime.bind(this);
    this.selecionarJogador = this.selecionarJogador.bind(this);
    this.removerJogador = this.removerJogador.bind(this);
    this.acaoListenerJogador = this.acaoListenerJogador.bind(this);
  }

  componentDidMount() {
    const { campeonato = env.CAMPEONATO } = this.props;

    Campeonato.onAlteracaoJogador(campeonato, this.acaoListenerJogador);
    Campeonato.onAtualizacao(this.inicializar);
  }

  async inicializar() {
    await this.setState({ loading: true });
    const grupos = [];
    const jogadoresTotal = [];
    const { campeonato = env.CAMPEONATO } = this.props;
    const acompanhamentoDisponivel = await Campeonato.isAcompanhamentoDisponivel();
    if (!acompanhamentoDisponivel) {
      this.setState({ loading: false, acompanhamentoDisponivel });
      return null;
    }
    const titulo = await Campeonato.consultarTitulo(campeonato);
    const timesCampeonato = await Campeonato.listarTimesPorCampeonato(campeonato);
    const gruposCampeonato = await Campeonato.listarGruposPorCampeonato(campeonato);
    const promiseBase = gruposCampeonato && gruposCampeonato.length > 0 ? gruposCampeonato.map(async grupo => await Campeonato.listarJogadoresPorGrupo(grupo)) : [];
    for (const grupo of promiseBase) {
      grupos.push(await grupo);
    }
    grupos.map(grupo => jogadoresTotal.push(...grupo));
    const selecao = await Campeonato.listarIdsJogadoresSelecaoPorCampeonato(campeonato);
    const jogadores = jogadoresTotal.filter(jogador => !selecao.includes(jogador.id));
    await this.atualizarGrupos(jogadores);
    await this.setState({ loading: false, times: timesCampeonato, selecaoRecente: false, titulo, jogadores, acompanhamentoDisponivel });
  }

  async acaoListenerJogador(acao) {
    try {
      const { countAcao, times } = this.state;
      const { tipo, idTime, jogador } = acao;
      const { nome, nomeCompleto } = jogador;
      const time = times.filter(item => item.id === idTime);

      if (countAcao === 0) {
        const novoContador = countAcao + 1;
        this.setState({ countAcao: novoContador });
        return false;
      }

      if (tipo === 'remover') {
        if (this.removerJogador(idTime, jogador)) {
          const mensagem = `Jogador ${nome ? nome : nomeCompleto} foi removido da Equipe ${time[0].nome}`;
          this.setState({ mensagem, timeSelecionado: time[0] });
        }
      } else if (tipo === 'selecionar') {
        if (this.selecionarJogador(idTime, jogador)) {
          const mensagem = `Jogador ${nome ? nome : nomeCompleto} foi selecionado na Equipe ${time[0].nome}`;
          this.setState({ mensagem, timeSelecionado: time[0] });
        }
      }
    } catch (e) {
      console.log(e);
    }
  }

  async atualizarGrupos(jogadores) {
    const gruposTela = montarGrupos(jogadores);
    const jogadores1 = gruposTela[0].jogadores;
    const jogadores2 = gruposTela[1].jogadores;
    const grupo1 = gruposTela[0].grupos;
    const grupo2 = gruposTela[1].grupos;
    await this.setState({ jogadores1, jogadores2, grupo1, grupo2 });
  }

  async selecionarJogador(idTime, jogador) {
    try {
      const { times, jogadores } = this.state;
      const indexTime = times.findIndex(item => item.id === idTime);
      if (times[indexTime].jogadores) {
        times[indexTime].jogadores.push(jogador);
      } else {
        times[indexTime].jogadores = [jogador];
      }
      const novosJogadores = jogadores.filter(item => item.id !== jogador.id);
      this.atualizarGrupos(novosJogadores);
      await this.setState({ times, jogadores: novosJogadores, selecaoRecente: true });
      return true;
    } catch (e) {
      console.log(e);
      return false;
    }
  }

  async removerJogador(idTime, jogador) {
    try {
      const { times, jogadores } = this.state;
      jogadores.push(jogador);
      const novosJogadores = times[times.findIndex(item => item.id === idTime)].jogadores.filter(item => item.id !== jogador.id);
      times[times.findIndex(item => item.id === idTime)].jogadores = novosJogadores;
      this.atualizarGrupos(jogadores);
      await this.setState({ times, jogadores, selecaoRecente: false });
      return true;
    } catch (e) {
      console.log(e);
      return false;
    }
  }

  async selecionarTime(time) {
    await this.setState({ timeSelecionado: time, selecaoRecente: false });
  }

  async cancelarSelecaoTime() {
    await this.setState({ timeSelecionado: { id: 0, nome: '' }, selecaoRecente: false });
  }

  render() {
    const { acompanhamentoDisponivel, loading, titulo, mensagem, times, jogadores1, jogadores2, grupo1, grupo2, timeSelecionado } = this.state;
    // const { loading, titulo, times, jogadores1, jogadores2, timeSelecionado, selecaoRecente } = this.state;

    if (loading) {
      return <Carregando />;
    }

    if (!acompanhamentoDisponivel) {
      return (
        <div className="App">
          <Cabecalho acompanhamento titulo="O acompanhamento da seleção não está disponível no momento." mensagem={mensagem} />
          <div className="Body" />
        </div>
      );
    }

    return (
      <div className="App">
        <Cabecalho acompanhamento titulo={titulo} mensagem={mensagem} />
        <div className="Body">
          <Times
            acompanhamento
            times={times}
            timeSelecionado={timeSelecionado}
            selecionarTime={this.selecionarTime}
            removerJogador={this.removerJogador}
          />
          <div className="Grupos">
            <div className="TituloBody">
              <p>Grupos</p>
            </div>
            {jogadores1.length === 0 ? (
              <div className="SelecaoVazia">
                <p>Confira ao lado a relação final dos jogadores selecionados.</p>
              </div>
            ) : (
              <Grupo
                acompanhamento
                nome={grupo1}
                jogadores={jogadores1}
                selecionarJogador={this.selecionarJogador}
                // acaoAtiva={timeSelecionado.nome && !selecaoRecente}
                acaoAtiva={timeSelecionado.nome || false}
                idTime={timeSelecionado.id}
              />
            )}

            {jogadores2.length > 0 ? (
              <Grupo
                acompanhamento
                nome={grupo2}
                jogadores={jogadores2}
                selecionarJogador={this.selecionarJogador}
                // acaoAtiva={timeSelecionado.nome && !selecaoRecente}
                acaoAtiva={timeSelecionado.nome || false}
                idTime={timeSelecionado.id}
              />
            ) : null}
          </div>
        </div>
      </div>
    );
  }
}
